import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SanityResponsiveImage from '~/components/Sanity/SanityResponsiveImage.vue';
import { ISanityImageWithObjectPosition } from '~/types/sanity-objects';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoBackground',
  props: {
    imageLandscape: null,
    imagePortrait: null,
    overlay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  imageLandscape?: ISanityImageWithObjectPosition;
  imagePortrait?: ISanityImageWithObjectPosition;
  overlay?: boolean;
}



const imageLandscapeConfig = computed(() => {
  return props.imageLandscape
    ? { image: props.imageLandscape, maxWidth: '100vw' as const }
    : undefined;
});

const imageLandscapePosition = computed(() => {
  return `${props.imageLandscape?.objectPosition?.x || 'center'} ${
    props.imageLandscape?.objectPosition?.y || 'center'
  }`;
});

const imagePortraitConfig = computed(() => {
  return props.imagePortrait
    ? { image: props.imagePortrait, maxWidth: '100vw' as const }
    : undefined;
});

const imagePortraitPosition = computed(() => {
  return `${props.imagePortrait?.objectPosition?.x || 'center'} ${
    props.imagePortrait?.objectPosition?.y || 'center'
  }`;
});

return { __sfc: true,props, imageLandscapeConfig, imageLandscapePosition, imagePortraitConfig, imagePortraitPosition, SanityResponsiveImage }
}

})